import React from 'react';
import { connect } from 'react-redux';
import AppWrapper from '../app_wrapper';
import CharitableGivingMobile from '../components_mobile/pages/CharitableGiving';
import CharitableGivingDesktop from '../components_desktop/pages/CharitableGiving';
import { apiGet } from '../modules/api';
import metadata from '../helpers/metadataHelper';

const CharitableGivingComponent = props => (
  <>
    <AppWrapper
      desktopComp={<CharitableGivingDesktop {...props} />}
      mobileComp={<CharitableGivingMobile {...props} />}
      metadata={metadata.charitableGiving}
    />
  </>
);

CharitableGivingComponent.getInitialProps = ({ store, req, res }) => {
  return store.dispatch(apiGet('api/home', req, res));
};

const mapStateToProps = ({ api: { s3BasePath } }) => {
  return {
    s3BasePath,
  };
};

const CharitableGiving = connect(mapStateToProps)(CharitableGivingComponent);
export default CharitableGiving;
